'use strict';

angular.module('directives.selfAccessRequestDecision', [])
 .directive('selfAccessRequestDecision', ['$document',function ($document) {
     return {
         scope: {
             model: '=',
             version: '@',
             name: '=',
             disabled: '=',
             processStepId: '=',
             onUpdate :'&',
         },
         template: '<div ng-include="getTemplateUrl()"></div>',
         controller: ['$scope', 'selfAccessRequestService', function ($scope, selfAccessRequestService) {

             $scope.getTemplateUrl = function () {
                 var templateUrl = '/app/shared/components/directives/selfAccessRequestDecision.';

                 // Uses version
                 if (!_.isUndefined($scope.version)) {
                     templateUrl += ($scope.version + '.tpl.html');
                     return templateUrl;
                 };

                 if (_.isUndefined($scope.model) || _.isUndefined($scope.model.SelfAccessRequestTemplate)) return;

                 // Uses model type template
                 templateUrl += ($scope.model.SelfAccessRequestTemplate + '.tpl.html');
                 return templateUrl;
             };
         }]
     }
 }]);